import { WizardState } from '../types/WigWizard';

export function saveWizardState(state: WizardState, redirectAfterLogin?: string) {
  localStorage.setItem('wizardState', JSON.stringify(
    redirectAfterLogin ? { ...state, redirectAfterLogin }
      : state
  ));
}

export function setRedirectAfterLoginOrSignup(redirectAfterLogin: string) {
  const state = retrieveWizardState()
  localStorage.setItem('wizardState', JSON.stringify(
    { ...state, redirectAfterLogin }
  ));
}

export function retrieveWizardState() {
  return JSON.parse(localStorage.getItem('wizardState')) as WizardState
}

export function clearWizardState() {
  localStorage.clear()
}
